import Box from '@material-ui/core/Box';
import { Palette } from '@woundtech/ui-colors';
import { PlaceholderKind } from '@woundtech/ui-constants';
import { fullAddressFormat } from 'fhir/general/Address';
import { fullNameFormat } from 'fhir/general/HumanName';
import React, { useMemo } from 'react';
import ResourceCard from 'styleguide/display/ResourceCard';
import { phoneNumber } from 'styleguide/form/Telecom/formatters';
import { NPI_SYSTEM, ORGNAIZATION_SUB_TYPE } from '../../constants';
import { getSystemCode } from '../utils';
import { identifierBySystem } from 'fhir/general/Identifier/formatters';

type Props = {
  data: any;
  onClick: () => void;
  customAttributes?: any;
  title?: string;
  cardStatus?: string;
  type?: boolean;
};

const Component: React.FC<Props> = ({
  data,
  onClick,
  customAttributes = [],
  title,
  cardStatus,
  type,
}) => {
  const attributes = useMemo(() => {
    const telecom = phoneNumber(
      data?.telecom?.find((item) => item?.system === 'phone')
    );
    const orgType = getSystemCode(data?.type, ORGNAIZATION_SUB_TYPE)
      ?.coding?.[0]?.display;

    const npiNumber = identifierBySystem(
      data?.identifier,
      NPI_SYSTEM
    )
  
    const npiData = (npiNumber === '--') ? [] : [{
      name: 'NPI',
      value: npiNumber,
      columns : 1
    }]

    if (type) {
      return [
        ...npiData,
        {
          icon: 'phone',
          value: telecom,
          columns: 2,
        },
        {
          icon: 'location_on',
          value: fullAddressFormat(data?.address?.[0]),
          columns: 2,
        },
      ];
    }
    if (orgType) {
      return [
        ...npiData,
        {
          name: 'Type',
          value: orgType || PlaceholderKind.NotAvailable,
          columns: 2,
        },
        {
          icon: 'location_on',
          value: fullAddressFormat(data?.address?.[0]),
          columns: 2,
        },
      ];
    }
  }, [data, type]);

  const { displayName, status, statusColor } = useMemo(() => {
    const displayName =
      typeof data?.name !== 'string' ? fullNameFormat(data?.name) : data?.name;
    const status = customAttributes?.length ? cardStatus : data?.active;
    const statusText = status ? 'Active' : 'Inactive';
    const statusColor =
      statusText === 'Active' ? Palette.Teal.Main : Palette.Orange.Main;
    return { status: statusText, statusColor, displayName };
  }, [data, customAttributes, cardStatus]);

  return (
    <Box onClick={onClick}>
      <ResourceCard
        title={title || displayName}
        attributes={customAttributes?.length ? customAttributes : attributes}
        status={status}
        statusBackgroundColor={statusColor}
        hideAvatar
      />
    </Box>
  );
};

export default React.memo(Component);
